import React, { useContext } from 'react';
import { required } from '@ubeya/shared/utils/form';
import InputField from '../../FormFields/InputField';
import ConfigContext from '../../../contexts/ConfigContext';
import { CheckBoxField } from '../..';
import { EditableByAdmins } from './EditableByAdmins';

const SimpleFieldFormWithExpiration = ({ editMode, hideExpiration = false, showLimitEditAdminsToggle = false }) => {
  const { t } = useContext(ConfigContext);

  return (
    <>
      <InputField
        name="name"
        title={t('name')}
        placeholder={t('selectNameToField')}
        validate={required}
        required
        autoFocus
        className="full"
      />
      {!hideExpiration && (
        <CheckBoxField name="hasExpiration" title={t('hasExpiration')} className="full" disabled={editMode} />
      )}
      {showLimitEditAdminsToggle && <EditableByAdmins />}
    </>
  );
};

export default SimpleFieldFormWithExpiration;
